import { render, staticRenderFns } from "./TermosDeUso.vue?vue&type=template&id=59d36a74&scoped=true&"
import script from "./TermosDeUso.vue?vue&type=script&lang=js&"
export * from "./TermosDeUso.vue?vue&type=script&lang=js&"
import style0 from "./TermosDeUso.vue?vue&type=style&index=0&id=59d36a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d36a74",
  null
  
)

export default component.exports